<div class="settings_block" id="idleExpBlock">
    <div class="settings_headers" id="idleExpHeaders">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1442_2317)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.7725 1.5285C12.5154 1.50952 12.2578 1.50001 12 1.5V0C12.2948 0.000143741 12.5895 0.0111512 12.8835 0.033L12.7725 1.5285ZM15.7785 2.2035C15.2977 2.01796 14.8038 1.86805 14.301 1.755L14.6295 0.291C15.204 0.42 15.7695 0.591 16.3185 0.804L15.7785 2.2035ZM17.8335 3.2685C17.619 3.12547 17.3994 2.99038 17.175 2.8635L17.9145 1.5585C18.4274 1.8491 18.9182 2.17699 19.383 2.5395L18.4605 3.723C18.2571 3.56435 18.048 3.41324 17.8335 3.27V3.2685ZM20.5845 5.9535C20.2878 5.53196 19.9604 5.13288 19.605 4.7595L20.691 3.7245C21.096 4.152 21.471 4.6095 21.8115 5.0895L20.5845 5.9535ZM21.7005 7.9815C21.602 7.74369 21.495 7.50953 21.3795 7.2795L22.719 6.6045C22.9839 7.13113 23.2095 7.67661 23.394 8.2365L21.969 8.706C21.8884 8.4613 21.7988 8.21964 21.7005 7.9815ZM22.4955 11.742C22.4834 11.2265 22.4332 10.7126 22.3455 10.2045L23.823 9.9495C23.9235 10.5285 23.982 11.1165 23.997 11.7045L22.497 11.742H22.4955ZM22.299 14.049C22.3485 13.794 22.389 13.5405 22.4205 13.284L23.91 13.4685C23.838 14.0537 23.7226 14.6328 23.565 15.201L22.119 14.8005C22.188 14.553 22.248 14.3025 22.299 14.049ZM20.871 17.6175C21.147 17.1825 21.39 16.7265 21.6 16.2555L22.971 16.863C22.731 17.403 22.4535 17.922 22.1385 18.42L20.871 17.6175ZM19.425 19.425C19.608 19.242 19.7835 19.053 19.95 18.858L21.087 19.8375C20.8945 20.0608 20.6938 20.2769 20.4855 20.4855L19.425 19.425Z"
                    fill="#262626" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 1.5C10.2734 1.50012 8.57336 1.92607 7.05061 2.74011C5.52786 3.55415 4.22937 4.73115 3.27013 6.16687C2.3109 7.6026 1.72054 9.25272 1.55134 10.9711C1.38214 12.6895 1.63932 14.423 2.30011 16.0183C2.9609 17.6135 4.0049 19.0212 5.33964 20.1166C6.67437 21.212 8.25865 21.9613 9.95215 22.2982C11.6456 22.6351 13.3961 22.5492 15.0484 22.048C16.7008 21.5468 18.204 20.6459 19.425 19.425L20.4855 20.4855C19.0902 21.8817 17.3719 22.9121 15.4831 23.4855C13.5943 24.0589 11.5932 24.1575 9.65714 23.7727C7.72109 23.3879 5.90983 22.5315 4.38387 21.2793C2.85791 20.0272 1.66435 18.418 0.908949 16.5943C0.153547 14.7707 -0.140374 12.7888 0.0532282 10.8244C0.24683 8.85999 0.921977 6.97365 2.01885 5.33253C3.11572 3.6914 4.60045 2.34617 6.34149 1.416C8.08253 0.485843 10.0261 -0.000523098 12 4.22187e-07V1.5Z"
                    fill="#262626" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.25 4.5C11.4489 4.5 11.6397 4.57902 11.7803 4.71967C11.921 4.86032 12 5.05109 12 5.25V13.065L16.872 15.849C17.0397 15.9502 17.1612 16.1129 17.2104 16.3024C17.2597 16.492 17.2329 16.6933 17.1358 16.8633C17.0386 17.0333 16.8788 17.1586 16.6905 17.2124C16.5022 17.2661 16.3003 17.2441 16.128 17.151L10.878 14.151C10.7632 14.0854 10.6678 13.9907 10.6014 13.8764C10.535 13.762 10.5 13.6322 10.5 13.5V5.25C10.5 5.05109 10.579 4.86032 10.7197 4.71967C10.8603 4.57902 11.0511 4.5 11.25 4.5Z"
                    fill="#262626" />
            </g>
            <defs>
                <clipPath id="clip0_1442_2317">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <span i18n="@@device-settings.idle-experience-title"><strong>IDLE EXPERIENCE</strong></span>
    </div>
    <div class="settings_body" id="idleExpBody">
        <div class="setting_info" id="settingInfo">
            <span i18n="@@device-settings.idle-experience-desc"><strong>Edit the idle experience in this
                    device</strong></span>
        </div>
        <div class="form-group mb-4" id="frmGrpIdleTime">
            <label for="idleTime"><span i18n="@@device-settings.time-untile-idle">Time Until Idle</span></label>
            <select class="form-control" id="idleTime" (change)='customizableButton($event,"time")' [disabled]='OledContentEnabled'>
                <option value='30' [selected]='OledContentEnabled || selectedIdleTime == 30'>{{globalconst.THIRTY_SEC}}</option>
                <option value='45' [selected]= 'selectedIdleTime == 45'>{{globalconst.FORTYFIVE_SEC}}</option>
                <option value='60' [selected]= 'selectedIdleTime == 60'><span>{{globalconst.ONE_MINUTE}}</span></option>
                <option value='90' [selected]= 'selectedIdleTime == 90'><span>{{globalconst.ONE_AND_HALF_MINUTE}}</span></option>
                <option value='120' [selected]='!OledContentEnabled || selectedIdleTime == 120'><span>{{globalconst.TWO_MINUTES}}</span></option>
                <option value='300' [selected]= 'selectedIdleTime == 300'><span>{{globalconst.FIVE_MINUTES}}</span> </option>
                <option value='600' [selected]= 'selectedIdleTime == 600'><span>{{globalconst.TEN_MINUTES}}</span> </option>
                <option value='1200' [selected]= 'selectedIdleTime == 1200'><span>{{globalconst.TWENTY_MINUTES}}</span> </option>
            </select>
        </div>
        <div class="idle_display_content" id="idleDisplayCon">
            <div class="mb-3 font-weight-bold" id="settingsIdleDisplay"><span i18n="@@device-settings.idle-display">Idle
                    Display</span></div>

            <div class="form-check mb-3"  id="OLEDDiv">
                <input class="form-check-input" type="checkbox" value="" id="OLED"
                    [checked]="OledContentEnabled" (click)="isOledContent($event)" />
                <label class="form-check-label" for="oledContent">
                    <span>{{oledExperience}}</span>
                    <span class="carbonhue d-block">{{oledExperienceSubstr}}</span>
                </label>
            </div>
        
            <!-- option to select fact tag rotation -->
            <div class="form-check mb-3  margin_205" id="fTagRotationfrmChck">
                <input type="radio" name="IdleExperience" id="fTagRotation" value=""
                    [checked]="(!isAttractorLoopRadionBtn && !isincreasePromotionRotation)" 
                    (click)="customizableButton('Fact Tag Rotation','factTag')" />
                <label class="form-check-label xyz" for="fTagRotation">
                    <span i18n="@@device-settings.fact-tag-rotation-title">Fact tag rotation</span>
                    <br />
                    <div class="carbonhue"><span>The key specifications of
                        the device will be shown in full screen.</span></div>
                </label>
            </div>
            <div class="form-check row_indented fact-tag-rotation margin08" *ngIf="(!isAttractorLoopRadionBtn  && !isincreasePromotionRotation)" id="burnInDiv">
                <input class="form-check-input" type="checkbox" value="" id="burnIn"
                    [checked]="true" disabled />
                <label class="form-check-label" for="burnIn">
                    <span>{{burnIn}}</span>
                </label>
            </div>
            <div class="form-check row_indented fact-tag-rotation margin08" id="includeLogoContentDiv">
                <input class="form-check-input" type="checkbox" value="" id="includeLogoContent"
                    [checked]="(isLogoContentEnabled && !isAttractorLoopRadionBtn && !isincreasePromotionRotation)" 
                    [disabled] = "(isAttractorLoopRadionBtn || isincreasePromotionRotation)" (click)="isLogoContent($event)" />
                <label class="form-check-label" for="includeLogoContent">
                    <span>{{includeLogoContent}}</span>
                    <span class="carbonhue d-block">{{includeLogoContentSubstr}}</span>
                </label>
            </div>
            <div class="form-check row_indented fact-tag-rotation margin08" id="includeSegmentContentDiv">
                <input class="form-check-input" type="checkbox" value="" id="includeSegmentContent"
                    [checked]="(isSegmentContentEnabled && !isAttractorLoopRadionBtn && !isincreasePromotionRotation)" 
                    [disabled] = "(isAttractorLoopRadionBtn || isincreasePromotionRotation)" (click)="isSegmentContent($event)" />
                <label class="form-check-label" for="includeSegmentContent">
                    <span>{{includeSegmentContent}}</span>
                    <span class="carbonhue d-block">{{includeSegmentContentSubstr}}</span>
                </label>
            </div>
            <div class="form-check mb-3" id="increaseRotationDiv">
                <input class="form-check-input" type="radio" id="increaseRotation" value=""
                    [checked]="isincreasePromotionRotation" (click)="isPromotionRotation($event)" />
                <label class="form-check-label" for="increaseRotation">
                    <span i18n="@@profile-info.idle-exp.promos-with-fact-tag">
                        <label class="form-check-label" for="increaseRotation">Promos with Fact Tag rotation</label>
                    </span>
                    <br />
                    <div class="carbonhue" id="increasePromotionDesc"><span
                            i18n="@@device-settings.increase-promotion-rotation-desc">The custom promo(s)
                            that you create will play, along with the experience of Fact Tag rotation.</span></div>
                </label>
            </div>
            <div class="form-check row_indented fact-tag-rotation margin08" *ngIf="isincreasePromotionRotation" id="burnInDiv">
                <input class="form-check-input" type="checkbox" value="" id="burnIn"
                    [checked]="true" disabled />
                <label class="form-check-label" for="burnIn">
                    <span>{{burnIn}}</span>
                </label>
            </div>            

            <!-- Option to select attract loop -->
            <div class="form-check mb-3" id="attractLoopDiv">
                <input class="form-check-input" type="radio" name="IdleExperience" value=""
                    [checked]="isAttractorLoopRadionBtn" id="attractLoop"
                    (click)="customizableButton('AttractLoop','attractloop')" />
                <label class="form-check-label  form-attract" for="attractLoop">
                    <span i18n="@@device-settings.attractor-loop">Attract Loop</span>
                    <br />
                    <div class="carbonhue" id="attractorLoopDescLine1Main">
                        <div id="attractorLoopDescLine1Child">
                            <span i18n="@@device-settings.attractor-loop-desc-line1">A creative, looping experience
                                designed to
                                attract attention which includes Burn-in Video and OEM Attract Loop Video (if
                                available).</span>
                        </div>
                    </div>
                </label>
            </div>
            <div class="form-check row_indented fact-tag-rotation margin08" *ngIf="isAttractorLoopRadionBtn" id="burnInDiv">
                <input class="form-check-input" type="checkbox" value="" id="burnIn"
                    [checked]="true" disabled />
                <label class="form-check-label" for="burnIn">
                    <span>{{burnIn}}</span>
                </label>
            </div>            
            <!-- Attract loop content selection -->
            <div id="DSLoopAccDiv">
                <div class="accordion" id="DSLoopAccordion" *ngIf="isAttractorLoopRadionBtn">
                    <div i18n="@@device-settings.desc.attract-loop-push-note" class="push-update-note"
                        *ngIf="isAttractLoopRecordFound" id="pushUpdateNote"><strong>Only connected devices with IPOS
                            versions 22CY3.0.0 or later can receive the Attract Loop push updates.</strong></div>
                    <iposcen-profile-attract-loop [selectedAttractLoopId]="selectedAttractLoopId"
                        (getAttractLoopRecordCount)="getAttractLoopRecordCount($event)"
                        (getSelectedAttractLoopData)="getSelectedAttractLoopData($event)">
                    </iposcen-profile-attract-loop>
                </div>

                <!-- <button [disabled]='!isRetailerId || !buttonEnabel' (click)='sendAttractLoop()' type="button"
            class="btn btn-primary gtmDevicesUpdateIdleExp">
            <span i18n="@@device-settings.update-idle-experience">Update Idle Experience</span>
          </button> -->
                <div class="button_wrapper justify-content-end" id="btnWrapper">
                    <button type="button" class="btn btn-outline-primary btn-lg gtmEditDeviceCancelPromoContent" data-dismiss="modal"
                        [disabled]='!buttonEnabel' (click)='cancel()'>
                        Cancel
                    </button>
                    <button type="button" [disabled]='!buttonEnabel'
                        class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent" (click)="sendDataToStore()">
                        <span i18n="@@device-price-content.title.save-changes">Save Changes</span>
                    </button>
                </div>

            </div>
        </div>
        <iposcen-password-popup #profileChangePasswordModal></iposcen-password-popup>
    </div>
</div>
<!--popup-message -->
<div class="container" id="containerPopup">
    <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialogMsg">
        <div class="modal-backdrop show" id="modalBackdropMsg"></div>
        <div class="modal" id="myModal">
            <div class="modal-dialog" id="myModalDialog">
                <div class="modal-content" id="modalContent">
                    <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="closeModal"><img
                            _ngcontent-fjy-c198="" alt="close" class="modal-close-icon"></div>
                    <div class="modal-body" id="modalBody">
                        <div *ngIf='!isCancel' class="action_on_pending_user" id="actionOnPendingUsr">
                            <span class="success_img"></span>
                        </div>
                        <div class="action-success-msg left_align_title" id="successMsg">
                            <span>{{successMessage}}</span>
                        </div>
                        <div class="card_desc left_align" id="desc">
                            <span>{{description}}</span>
                        </div>
                    </div>
                    <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
                        <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
                        <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>